import React, { useEffect, useState } from "react";
import {
  Button,
  Row,
  Col,
  Form,
  Space,
  AutoComplete,
  Collapse,
  Tag,
  Spin,
  Select,
  Modal,
} from "antd";
import { useTranslation } from "react-i18next";
import SearchSelect from "../../common/search-select/search-select";
import * as masterDataService from "../../service/masterDataService";
import * as settingsService from "../../service/settingsService";
import "./user-preference.scss";
import Notification from "../../service/notification";
import {
  CloseOutlined,
  UpOutlined,
  DownOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import { useStore } from "./../../store/store";
import { checkIsGCCCountry, checkIsInternalSourcing, checkIsKSAOperatingCountry, checkIsTurkeyKazak, checkIsUAEOperatingCountry } from "../../util/constantUtility";
import { OwnerType,CommonConstants } from '../../constants/commonConstants';
import * as accountService from "../../service/accountService";
import * as localStorageService from "../../service/localStorageService";
import { LocalStorageKeys } from "../../constants/localStorageKeys";
import { BrandColors, brandColor } from "../../constants/brand";


const UserPreferences = () => {
  const { t } = useTranslation();
  const { Panel } = Collapse;
  const [preferenceForm] = Form.useForm();
  const [countriesListWaiter, setCountriesListWaiter] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const [cityWaiter, setCityWaiter] = useState(false);
  const [countryStateOrCityOptions, setCountryStateOrCityOptions] = useState(
    []
  );
  const [stateOptions, setStateOptions] = useState([]);
  const [truckTypeWaiter, setTruckTypeWaiter] = useState(false);
  const [truckTypeOptions, setTruckTypeOptions] = useState([]);
  const [commodityTypeOptions, setCommodityTypeOptions] = useState([]);
  const [interSourcerTypeOptions, setInterSourcerTypeOptions] = useState([]);

  const [commodityTypeWaiter, setCommodityTypeWaiter] = useState(false);
  const [savePreferenceLoader, setSavePreferenceLoader] = useState(false);
  const [userPreferenceLoader, setUserPreferenceLoader] = useState(true);
  const [prefrence,setprefrence] = useState();
  const [customerListWaiter, setCustomerListWaiter] = useState(false);
  const [classOption, setClassOption] = useState([]);
  const [selectedCustomerList, setSelectedCustomerList] = useState([]);
  const { user, saveUser } = useStore();
  const [activeKeys, setActiveKeys] = useState([
    "Customer",
    "countryStateAndCity",
    "truckType",
    "commodity",
    "Class",
  ]);
  // Add this new state to force re-renders
  const [updateTrigger, setUpdateTrigger] = useState(0);

  useEffect(() => {
    getUserPreference();
    getCountries();
    getTruckType();
    getCommodityMaster();
    if(checkIsInternalSourcing(user?.userRole) && checkIsTurkeyKazak(user?.operatingCountry)){
      getCountryWiseClassMaster();
    }
  }, []);

  const getUserDetail = () => {
      accountService
        .getUserDetail()
        .then((res) => {
          saveUser(res.data.data);
        })
        .catch((error) =>
          console.error("Error while fetching user detail", error)
        );
    };

  //Prefilled user preferences
  const getUserPreference = () => {
    settingsService
      .getUserPreferences()
      .then((res) => {
        if (res.data.data) {
          let userPreferences = res.data.data;
          preferenceForm.setFieldValue(
            "country",
            userPreferences.countries?.length > 0
              ? userPreferences.countries
              : []
          );
          preferenceForm.setFieldValue(
            "state",
            userPreferences.states?.length > 0 ? userPreferences.states : []
          );
          preferenceForm.setFieldValue(
            "city",
            userPreferences.cities?.length > 0 ? userPreferences.cities : []
          );
          preferenceForm.setFieldValue(
            "truckType",
            userPreferences.truckTypes?.length > 0
              ? userPreferences.truckTypes
              : []
          );
          preferenceForm.setFieldValue(
            "commodity",
            userPreferences.commodities?.length > 0
              ? userPreferences.commodities
              : []
          );
          preferenceForm.setFieldValue(
            "class",
            userPreferences.classes?.length > 0
              ? userPreferences.classes
              : []
          );
          if(userPreferences?.shipperList?.length > 0){
            setSelectedCustomerList(userPreferences.shipperList);
            let customers=userPreferences.shipperList.map((ele)=>ele.shipperName);
            preferenceForm.setFieldValue(
              "selectedCustomer",
              customers?.length > 0
                ? customers
                : []
            );
          }
          

        }
        setUserPreferenceLoader(false);
      })
      .catch((error) => {
        console.error("Error while loading user preference", error);
        setUserPreferenceLoader(false);
      });
  };
  const getCountries = () => {
    setCountriesListWaiter(true);
    masterDataService
      .getCountryMaster()
      .then((res) => {
        setCountriesListWaiter(false);
        if (res.status === 200) {
          const formattedOptions = res.data.map((country) => ({
            label: country.name,
            value: country.name,
            country_code: country.country_code,
          }));
          setCountryOptions(formattedOptions);
        }
      })
      .catch((err) => {
        setCountriesListWaiter(false);
      });
  };

  //handle select autocomplete
  const onSelectCountryStateOrCity = (option) => {
    let options = preferenceForm.getFieldValue(option.type);
    if (!options || options.length == 0) {
      options = [];
      options.push(option.value);
    } else {
      if (options.findIndex((z) => z == option.value) == -1) {
        options.push(option.value);
      }
    }
    preferenceForm.setFieldValue(option.type, options);
    preferenceForm.setFieldValue("countryStateAndCity", "");
    setUpdateTrigger((prev) => prev + 1);
  };

  //get city list for source
  const getCountryStateOrCityList = (value, index) => {
    setCityWaiter(true);
    masterDataService
      .getCountryStateCityMasterBasedOnSearch(value)
      .then((response) => {
        if (response.status === 200) {
          setCityWaiter(false);
          setCountryStateOrCityOptions(groupDataByType(response.data));
        }
      })
      .catch((error) => {
        setCityWaiter(false);
        setCountryStateOrCityOptions([]);
      });
  };

  //group data by type for global search option
  function groupDataByType(apiResponse) {
    if (apiResponse && apiResponse.length > 0) {
      const groupedData = apiResponse.reduce((acc, item) => {
        const { type, key } = item;
        if (!acc[type]) {
          acc[type] = [];
        }
        acc[type].push({
          label: getOptionLabel(key, type),
          value: key,
          type: type,
        });
        return acc;
      }, {});

      let options = Object.keys(groupedData).map((key, index) => ({
        label: getCategoryLabel(key, index),
        sortOrder: getSortOrder(key),
        options: groupedData[key],
      }));
      return options.sort((a, b) => a.sortOrder - b.sortOrder);
    } else {
      return [];
    }
  }

  //to display country option on top set order
  const getSortOrder = (type) => {
    switch (type) {
      case "country":
        return 1;
      case "state":
        return 2;
      case "city":
        return 3;
      default:
        return 0;
    }
  };

  const getOptionLabel = (key, type) => {
    return (
      <>
        <Space direction="horizontal" className="load-search-option">
          <span className="label-text">{key}</span>
        </Space>
      </>
    );
  };
  const getCategoryLabel = (key, index) => {
    return (
      <>
        {key !== "country" && <hr className="hr-category-label" />}{" "}
        <span className="category-text">{key}</span>{" "}
      </>
    );
  };

  const getTruckType = () => {
    setTruckTypeOptions([]);
    setTruckTypeWaiter(true);
    masterDataService
      .getTruckType("truckType", "FTL")
      .then((response) => {

        setTruckTypeWaiter(false);
        let truckTypes = [];
        if (checkIsGCCCountry(user.operatingCountry)) {
          let gccTruckTypes = response.data.filter(z => z.region == "GCC");
          let nonGccTruckTypes = response.data.filter(z => z.region != "GCC");
          truckTypes = [...gccTruckTypes, ...nonGccTruckTypes];
        }
        else if (user.operatingCountry == "Turkey") {
          let gccTruckTypes = response.data.filter(z => z.region?.toLowerCase() == "tr");
          let nonGccTruckTypes = response.data.filter(z => z.region?.toLowerCase() != "tr");
          truckTypes = [...gccTruckTypes, ...nonGccTruckTypes];
        } else if (user.operatingCountry == "Kazakhstan") {
          let gccTruckTypes = response.data.filter(z => z.region?.toLowerCase() == "kaz");
          let nonGccTruckTypes = response.data.filter(z => z.region?.toLowerCase() != "kaz");
          truckTypes = [...gccTruckTypes, ...nonGccTruckTypes];
        } else {
          if (response.data.some(z => z.region?.toLowerCase() == user.operatingCountry?.toLowerCase())) {
            let gccTruckTypes = response.data.filter(z => z.region?.toLowerCase() == user.operatingCountry?.toLowerCase());
            let nonGccTruckTypes = response.data.filter(z => z.region?.toLowerCase() != user.operatingCountry?.toLowerCase());
            truckTypes = [...gccTruckTypes, ...nonGccTruckTypes];
          }
        }




        setTruckTypeOptions(
          truckTypes.length > 0
            ? Array.from(new Set(truckTypes.map((truck) => truck.type))).map((type) => ({
              label: type,
              value: type,
            }))
            : []
        );
      })
      .catch((error) => {
        setTruckTypeWaiter(false);
      });
  };

  const getCommodityMaster = async () => {
    try {
      let languageISOCode = localStorageService.getValue(LocalStorageKeys.Lang) ? localStorageService.getValue(LocalStorageKeys.Lang) : CommonConstants.DefaultLanguageCode;
      setCommodityTypeWaiter(true);
      const res = await masterDataService.getCommodityMaster(languageISOCode);
      setCommodityTypeWaiter(false);
      if (res.status === 200) {
        // var commodityGrp = res.data.map((row) => row.commodityName);
        // commodityGrp = commodityGrp.filter(function (item, pos) {
        //   return commodityGrp.indexOf(item) === pos;
        // });
        // setCommodityTypeOptions(
        //   commodityGrp.map((row) => ({ label: row, value: row }))
        // );
          const uniqueCommodities = res.data?.filter(
                (row, index, self) =>
                  index === self.findIndex((r) => r.commodityName === row.commodityName)
              );
        setCommodityTypeOptions(
          uniqueCommodities?.map((row) => ({
            label: row?.localizeCommodityName,
            value: row?.commodityName
          }))
        );


      }
    } catch (err) {
      setCommodityTypeWaiter(false);
    }
  };
  const getInternalSourcerPreferences = async (searchValue) => {  
    const payload=  {
     searchShipperName: searchValue
    }

    try {
      setCustomerListWaiter(true);
      const res = await settingsService.getShipperListForInternalSourcer(payload );
       setCustomerListWaiter(false);
      if (res.status === 200) {
        let shipperList = res?.data?.data?.map((ele) => {
          return {
            label: ele.shipperName,
            value: ele.shipperId,
          };
        });
        setInterSourcerTypeOptions(shipperList);
      }
    } catch (err) {
       setCustomerListWaiter(false);
    }
  };

  const handleBookmarkConfirmModal = () => {
    Modal.confirm({
      title: t("PREFERENCES_CONFIRM_MESSAGE"),
      okText: t("COMMON_YES_BTN"),
      okType: "danger",
      cancelText: t("COMMON_NO_BTN"),
      centered: true,
      okButtonProps: {
        style: { backgroundColor: "var(--brand-primary, #ff833c)", borderColor: "var(--brand-primary, #ff833c)", color: "white" } 
      },
      cancelButtonProps: { style: { borderColor: "var(--brand-primary, #ff833c)", color: "var(--brand-primary, #ff833c)" }  },
      footer: (dom) => <div className="custom-modal-footer">{dom}</div>,
      onOk: () => {
        onCancel();
      },
    }
    );
  };

  const onCancel = () => {
    preferenceForm.resetFields();
    setSelectedCustomerList([]);
  };

  const savePreferences = () => {
    setSavePreferenceLoader(true);
    try {
      let payload = {
        isPreferenceSet: true,
        countries:
          preferenceForm.getFieldValue("country")?.length > 0
            ? preferenceForm.getFieldValue("country")
            : [],
        states:
          preferenceForm.getFieldValue("state")?.length > 0
            ? preferenceForm.getFieldValue("state")
            : [],
        cities:
          preferenceForm.getFieldValue("city")?.length > 0
            ? preferenceForm.getFieldValue("city")
            : [],
        truckTypes:
          preferenceForm.getFieldValue("truckType")?.length > 0
            ? preferenceForm.getFieldValue("truckType")
            : [],

        commodities:
          preferenceForm.getFieldValue("commodity")?.length > 0
            ? preferenceForm.getFieldValue("commodity")
            : [],
         shipperList:(checkIsInternalSourcing(user?.userRole)) ? selectedCustomerList?.length > 0 ? selectedCustomerList: []: [],
         classes:(checkIsInternalSourcing(user?.userRole) && checkIsTurkeyKazak(user?.operatingCountry)) ? preferenceForm.getFieldValue("class")?.length > 0
         ? preferenceForm.getFieldValue("class")
         : []: []
      };

      settingsService
        .savePreferences(payload)
        .then((response) => {
          setSavePreferenceLoader(false);
          if (response.status === 200) {
            Notification.success('success',t("PREFERENCES_SUCCESS_MESSAGE"));
            getUserDetail();
            
          }
        })
        .catch((error) => {
          setSavePreferenceLoader(false);
        });
    } catch (err) {
      setSavePreferenceLoader(false);
    }
  };

  //close generated tags
  const handleClose = (option, type) => {
    let options = preferenceForm.getFieldValue(type);
    preferenceForm.setFieldValue(
      type,
      options.filter((z) => z != option)
    );
    setUpdateTrigger((prev) => prev + 1);
  };

  //generate tags
  const generateTags = (options, type) => {
    return options.map((z) => {
      return (
        <>
          <Tag
            color={brandColor(BrandColors.primary, "rgb(255, 93, 0)")}
            key={z}
            closable
            style={{
              userSelect: "none",
              marginBottom: "8px",
              padding: "5px",
            }}
            onClose={() => handleClose(z, type)}
          >
            {" "}
            {z}
          </Tag>
        </>
      );
    });
  };

//class master turkey,kazak
  const getCountryWiseClassMaster = () => {
    masterDataService
      .getCountryWiseClassMaster(user?.operatingCountry)
      .then((response) => {
        if (response.status == 200) {
          let arr = response.data.map((ele) => {
            return {
              label: ele.name,
              value: ele.name,
            };
          });          
           if(user?.operatingCountry?.toLowerCase() === 'turkey'){
            let temp = arr.filter((ele)=>(!checkIsInterModelClassName(ele.value)));
            setClassOption(temp);
          }
          else{
            setClassOption(arr);
          }
        }
      })
      .catch((error) => {
        console.log("Error while getting data" + error);
      });
  };

  const checkIsInterModelClassName = (className) => {
    let interModalClasses = ["InterModal", "InterModal 2", "InterModal 3"]
    return interModalClasses.some(x => x == className);
  }

  const onSelectCustomer = (option)=>{
    let options = preferenceForm.getFieldValue("selectedCustomer");
    let newObj = {
      shipperId: option.value,
      shipperName: option.label,
    }
    if (!options || options.length == 0) {
      options = [];
      options.push(option.label);
      setSelectedCustomerList([{...newObj}]);
    } else {
      if (options?.findIndex((z) => z == option.value) == -1) {
        options.push(option.label);
        setSelectedCustomerList((prev) => [...prev, newObj]);
      }
    }
    preferenceForm.setFieldValue("selectedCustomer", options);
    preferenceForm.setFieldValue("customer", "");
    setUpdateTrigger((prev) => prev + 1);
  }

  const generateCustomerTag = (options, type) => {
    return options?.map((z) => {
      return (
        <>
          <Tag
            color={brandColor(BrandColors.primary, "rgb(255, 93, 0)")}
            key={z}
            closable
            style={{
              userSelect: "none",
              marginBottom: "8px",
              padding: "5px",
            }}
            onClose={() => handleCustomerClose(z, type)}
          >
            {" "}
            {z}
          </Tag>
        </>
      );
    });
  };

  const handleCustomerClose = (option, type) => {
    let options = preferenceForm.getFieldValue(type);
    preferenceForm.setFieldValue(
      type,
      options.filter((z) => z != option)
    );
    setUpdateTrigger((prev) => prev + 1);
    let localCollection = [...selectedCustomerList];
    localCollection = localCollection.filter((ele) => ele.shipperName !== option);
    setSelectedCustomerList(localCollection);
  };

  const handlePanelChange = (key) => {
    setActiveKeys((prevKeys) =>
      prevKeys.includes(key)
        ? prevKeys.filter((item) => item !== key)
        : [...prevKeys, key]
    );
  };

  return (
    <div className="user-preference-wrapper">
      <b>{t("SETTINGS_SET_PREFERENCES")}</b>
      <hr />
      {userPreferenceLoader ? (
        <Spin></Spin>
      ) : (
        <Form
          form={preferenceForm}
          layout={"vertical"}
          className="preference-form"
        >
          {checkIsInternalSourcing(user?.userRole) && <>
            <Collapse
            className="user-preference-collepse"
            activeKey={activeKeys} 
            onChange={() => handlePanelChange("Customer")}
            expandIcon={({ isActive }) =>
              isActive ? <UpOutlined /> : <DownOutlined />
            }
            expandIconPosition={"right"}
            accordion={false}
          >
            <Panel key={"Customer"} header={t("USER_PREF_CUSTOMER_HEADER")}>
              <Row>
                <Col span={24}>
                  <Form.Item name="customer">
                  <AutoComplete
                      className="floating-select"
                      showSearch={true}
                      placeholder={t("USER_PREF_CUSTOMER_PH")}
                      options={interSourcerTypeOptions}
                      popupClassName="global-city-search-popup"
                      loading={customerListWaiter}
                      onSelect={(val, option) =>
                        onSelectCustomer(option)
                      }
                      onSearch={(val) => {
                        if (val.length > 2) getInternalSourcerPreferences(val);
                      }}
                      suffix={
                        <SearchOutlined style={{ color: "var(--text-muted, rgba(0,0,0,.45))" }} />
                      }
                    />
                  </Form.Item>
                </Col>
                {preferenceForm.getFieldValue("selectedCustomer")?.length > 0 && <Col span={24}>
                  <div style={{ width: "100%", marginTop: "10px" }}>
                    <Row gutter={15}>
                      <Col span={4}>
                        <span>{t("USER_PREF_SELECTED_CUSTOMER_LBL")}</span>
                      </Col>
                      <Col span={1}></Col>
                      <Col span={19}>
                        {preferenceForm.getFieldValue("selectedCustomer")?.length > 0 ? (
                          generateCustomerTag(
                            preferenceForm.getFieldValue("selectedCustomer"),
                            "selectedCustomer"
                          )
                        ) : (
                          <>{t("USER_PREF_NO_DATA_LBL")}</>
                        )}
                      </Col>
                    </Row>
                    </div>
                </Col>}
              </Row>
            </Panel>
          </Collapse>
          </>}
          
          <Collapse
            className="user-preference-collepse"
            activeKey={activeKeys} onChange={() => handlePanelChange("countryStateAndCity")}
            expandIcon={({ isActive }) =>
              isActive ? <UpOutlined /> : <DownOutlined />
            }
            expandIconPosition={"right"}
            accordion={false}
          >
            <Panel key={"countryStateAndCity"} header={checkIsUAEOperatingCountry(user?.operatingCountry) ? t("USER_PREF_EMIRATE_HEADER"):checkIsKSAOperatingCountry(user?.operatingCountry) ? t("USER_PREF_PROVINCE_HEADER") : t("USER_PREF_COUNTRY_HEADER")}>
              <Row>
                <Col span={24}>
                  <Form.Item name="countryStateAndCity">
                    <AutoComplete
                      className="floating-select"
                      showSearch={true}
                      placeholder={t("LOAD_SOURCE_FILTER_PLACEHOLDER")}
                      options={countryStateOrCityOptions}
                      popupClassName="global-city-search-popup"
                      loading={cityWaiter}
                      onSelect={(val, option) =>
                        // handleSelectCity(val,option)
                        onSelectCountryStateOrCity(option)
                      }
                      onSearch={(val) => {
                        if (val.length > 2) getCountryStateOrCityList(val);
                      }}
                      suffix={
                        <SearchOutlined style={{ color: "var(--text-muted, rgba(0,0,0,.45))" }} />
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <div style={{ width: "100%", marginTop: "10px" }}>
                    <Row gutter={15}>
                      <Col span={4}>
                        <span>{t("USER_PREF_COUNTRY_LBL")}</span>
                      </Col>
                      <Col span={1}></Col>
                      <Col span={19}>
                        {preferenceForm.getFieldValue("country")?.length > 0 ? (
                          generateTags(
                            preferenceForm.getFieldValue("country"),
                            "country"
                          )
                        ) : (
                          <>{t("USER_PREF_NO_DATA_LBL")}</>
                        )}
                      </Col>
                    </Row>

                    <Row gutter={15}>
                      <Col span={4}>
                        <span>{checkIsUAEOperatingCountry(user?.operatingCountry) ? t("PREFERENCE_EMIRATE_LBL"):checkIsKSAOperatingCountry(user?.operatingCountry) ? t("PREFERENCE_PROVINCE_LBL") : t("USER_PREF_STATE_LBL")}</span>
                      </Col>
                      <Col span={1}></Col>
                      <Col span={19}>
                        {preferenceForm.getFieldValue("state")?.length > 0 ? (
                          generateTags(
                            preferenceForm.getFieldValue("state"),
                            "state"
                          )
                        ) : (
                          <>{t("USER_PREF_NO_DATA_LBL")}</>
                        )}
                      </Col>
                    </Row>
                    <Row gutter={15}>
                      <Col span={4}>
                        <span>{t("USER_PREF_CITY_LBL")}</span>
                      </Col>
                      <Col span={1}></Col>
                      <Col span={19}>
                        {preferenceForm.getFieldValue("city")?.length > 0 ? (
                          generateTags(
                            preferenceForm.getFieldValue("city"),
                            "city"
                          )
                        ) : (
                          <>{t("USER_PREF_NO_DATA_LBL")}</>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Panel>
          </Collapse>

          <Collapse
            className="user-preference-collepse"
            activeKey={activeKeys} onChange={() => handlePanelChange("truckType")}
            expandIcon={({ isActive }) =>
              isActive ? <UpOutlined /> : <DownOutlined />
            }
            expandIconPosition={"right"}
            accordion={false}
          >
            <Panel key={"truckType"} header={t("SETTINGS_TRUCK_TYPE")}>
              <Row>
                <Col span={24}>
                  <Form.Item name="truckType">
                    <Select
                      // defaultValue={defaultValue}
                      showSearch
                      className="select"
                      placeholder={t("USER_PREF_TRUCK_TYPE_PH")}
                      options={truckTypeOptions}
                      // fieldNames={{ label: "name", value: "name" }}
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      style={{
                        width: "100%",
                      }}
                      mode="multiple"
                      maxTagCount="responsive" 
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          <Collapse
            className="user-preference-collepse"
            activeKey={activeKeys} onChange={() => handlePanelChange("commodity")}
            expandIcon={({ isActive }) =>
              isActive ? <UpOutlined /> : <DownOutlined />
            }
            expandIconPosition={"right"}
            accordion={false}
          >
            <Panel key={"commodity"} header={t("SETTINGS_COMMODITY")}>
              <Row>
                <Col span={24}>
                  <Form.Item name="commodity">
                    <Select
                      // defaultValue={defaultValue}
                      showSearch
                      className="select"
                      placeholder={t("USER_PREF_COMMODITY_PH")}
                      options={commodityTypeOptions}
                      // fieldNames={{ label: "name", value: "name" }}
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      style={{
                        width: "100%",
                      }}
                      mode="multiple"
                      maxTagCount="responsive" 
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          {user?.userRole == OwnerType.INTERNAL_SOURCE && checkIsTurkeyKazak(user?.operatingCountry) && <>
          <Collapse
            className="user-preference-collepse"
            activeKey={activeKeys} onChange={() => handlePanelChange("Class")}
            expandIcon={({ isActive }) =>
              isActive ? <UpOutlined /> : <DownOutlined />
            }
            expandIconPosition={"right"}
            accordion={false}
          >
            <Panel key={"Class"} header={t("USER_PREF_CLASS_LBL")}>
              <Row>
                <Col span={24}>
                  <Form.Item name="class">
                    <Select
                      // defaultValue={defaultValue}
                      showSearch
                      className="select"
                      placeholder={t("USER_PREF_CLASS_PH")}
                      options={classOption}
                      // fieldNames={{ label: "name", value: "name" }}
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      style={{
                        width: "100%",
                      }}
                      mode="multiple"
                      maxTagCount="responsive" 

                    />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          </>}

          <Row justify={"end"}>
            <Space size="middle" className="button-space">
              <Button onClick={handleBookmarkConfirmModal} className="cancel-btn">
                {t("COMMON_RESET_BTN")}
              </Button>
              <Button
                className="submit-btn"
                loading={savePreferenceLoader}
                onClick={savePreferences}
              >
                {t("COMMON_SAVE_BTN")}
              </Button>
            </Space>
          </Row>
        </Form>
      )}
    </div>
  );
};

export default UserPreferences;
